var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSkeleton = function SvgSkeleton(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144,
    height: 154,
    fill: "none",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 18,
    fill: "#fff",
    fillOpacity: 0.06,
    rx: 6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 18,
    y: 104,
    fill: "#fff",
    fillOpacity: 0.06,
    rx: 6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 18,
    y: 32,
    fill: "#fff",
    fillOpacity: 0.06,
    rx: 6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 18,
    y: 64,
    fill: "#fff",
    fillOpacity: 0.06,
    rx: 6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 18,
    y: 136,
    fill: "#fff",
    fillOpacity: 0.06,
    rx: 6
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSkeleton);
export { ForwardRef as ReactComponent };